import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-movio/src/app/products/logistics/components/LogisticsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-movio/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-movio/src/components/Header.tsx");
